module.exports = __webpack_public_path__ + "static/media/cash-devolution.73397a17.png";